import './PageSection.scss';
import { ComponentProps, ReactNode } from 'react';
import cn from 'classnames';

interface PageSectionProps extends Omit<ComponentProps<'section'>, 'title'> {
  title?: ReactNode;
  actions?: ReactNode;
  description?: ReactNode;
  // Stretches the section to the page's remaining height.
  fillHeight?: boolean;
}

export const PageSection = ({
  title,
  actions,
  description,
  fillHeight = false,
  className,
  children,
  ...rest
}: PageSectionProps): ReactNode => (
  <section {...rest} className={cn('page-section', className, { 'fill-height': fillHeight })}>
    {title && (
      <div className='page-section-header'>
        <div>
          <div className='page-section-title'>{title}</div>
          {description && <div className='page-section-description'>{description}</div>}
        </div>
        {actions && <div className='page-section-actions'>{actions}</div>}
      </div>
    )}
    {children}
  </section>
);
